import React, { useState } from "react";
import { Button, Col, Input, Label, Row, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import POSKeypadModal from "./POSKeypadModal";
import { useDispatch } from "react-redux";
import { productActions } from "../../sagas/productSlice";
import Swal from "sweetalert2";

const POSProductFormModal = ({ onClose, categories, unites, product }) => {
    const dispatch = useDispatch();

    const [form, setForm] = useState({
        libelle: product?.libelle || "",
        codeBarre: product?.codeBarre || "",
        categorie: product?.categorieId || null,
        unite: product?.unite || null,
        prixVenteTTC1: product?.prixVenteTTC1 || "",
        prixAchatTTC: product?.prixAchatTTC || "",
        catSearch: "",
        unitSearch: ""
    });

    const [keypadField, setKeypadField] = useState(null);
    const [catModal, setCatModal] = useState(false);
    const [unitModal, setUnitModal] = useState(false);
    const [saving, setSaving] = useState(false);

    const setField = (name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    // 🔥 SAVE PRODUCT
    const handleSave = () => {
        console.log(form)
        if (!form.libelle || !form.categorie || !form.unite) {
            Swal.fire("Champs requis", "Libellé, Catégorie et Unité sont obligatoires", "warning");
            return;
        }

        setSaving(true);

        const articleDTO = {
            libelle: form.libelle,
            codeBarre: form.codeBarre,
            categorieId: form.categorie,
            unite: form.unite,
            prixVenteTTC1: Number(form.prixVenteTTC1 || 0),
            prixAchatTTC: Number(form.prixAchatTTC || 0),
            typeArticle: "STOCKABLE",
            tauxTVAAchat: 0.2,
            tauxTVAVente: 0.2,
            stockMinimal: product?.stockMinimal || 0,
            stockPhysique: product?.stockPhysique || 0,
            stockDisponible: product?.stockDisponible || 0,
            prixVariable: false,
            enStock: true,
            actif: true
        };

        const formData = new FormData();
        formData.append("article", new Blob([JSON.stringify(articleDTO)], { type: "application/json" }));

        const action = product
            ? productActions.updateProduct
            : productActions.addProduct;

        dispatch(
            action({
                id: product?.id,
                formData,
                onSuccess: () => {
                    Swal.fire("Succès", product ? "Produit modifié" : "Produit ajouté", "success");
                    setSaving(false);
                    onClose();
                },
                onError: () => {
                    setSaving(false);
                    Swal.fire("Erreur", "Impossible d'enregistrer", "error");
                }
            })
        );
    };


    return (
        <>
            <Row className="g-3">
                <Col md={6}>
                    <Label>Libellé</Label>
                    <Input readOnly className="pos-input" value={form.libelle} onClick={() => setKeypadField("libelle")} />
                </Col>

                <Col md={6}>
                    <Label>Code barre</Label>
                    <Input readOnly className="pos-input" value={form.codeBarre} onClick={() => setKeypadField("codeBarre")} />
                </Col>

                <Col md={6}>
                    <Label>Catégorie</Label>
                    <Input
                        readOnly
                        className="pos-input"
                        value={categories.find(c => c.id === form.categorie)?.libelle || ""}
                        onClick={() => setCatModal(true)}
                    />
                </Col>

                <Col md={6}>
                    <Label>Unité</Label>
                    <Input
                        readOnly
                        className="pos-input"
                        value={unites.find(u => u.code === form.unite)?.libelle || ""}
                        onClick={() => setUnitModal(true)}
                    />
                </Col>

                {/* <Col md={6}>
                    <Label>Prix Vente</Label>
                    <Input readOnly className="pos-input" value={form.prixVenteTTC1} onClick={() => setKeypadField("prixVenteTTC1")} />
                </Col>

                <Col md={6}>
                    <Label>Prix Achat</Label>
                    <Input readOnly className="pos-input" value={form.prixAchatTTC} onClick={() => setKeypadField("prixAchatTTC")} />
                </Col> */}
            </Row>

            <div className="pos-submit-bar mt-2">
                <Button color="secondary" size="lg" onClick={onClose} className="mx-2">Annuler</Button>
                <Button color="primary" size="lg" onClick={handleSave} disabled={saving}>
                    {saving ? <Spinner size="sm" /> : "Enregistrer"}
                </Button>
            </div>

            {/* KEYPAD */}
            <POSKeypadModal
                isOpen={!!keypadField}
                toggle={() => setKeypadField(null)}
                value={form[keypadField] || ""}
                onChange={(val) => setField(keypadField, val)}
            />

            {/* CATEGORY MODAL */}
            <Modal isOpen={catModal} toggle={() => setCatModal(false)} size="lg" centered>
                <ModalHeader toggle={() => setCatModal(false)}>Choisir catégorie</ModalHeader>
                <ModalBody>

                    {/* SEARCH BAR */}
                    <div
                        className="pos-search-bar mb-3"
                        onClick={() => setKeypadField("catSearch")}
                    >
                        <Input
                            readOnly
                            value={form.catSearch || ""}
                            placeholder="Rechercher catégorie..."
                            className="pos-input"
                        />
                    </div>

                    <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                        {categories
                            .filter(c =>
                                !form.catSearch ||
                                c.libelle.toLowerCase().includes(form.catSearch.toLowerCase())
                            )
                            .map(c => (
                                <Button
                                    key={c.id}
                                    color={form.categorie === c.id ? "primary" : "light"}
                                    className="w-100 text-start mb-2 py-3 fw-bold"
                                    onClick={() => {
                                        setField("categorie", c.id);
                                        setCatModal(false);
                                    }}
                                >
                                    {c.libelle}
                                </Button>
                            ))}
                    </div>

                </ModalBody>
            </Modal>

            {/* UNIT MODAL */}
            {/* UNITE SELECT MODAL */}
            <Modal isOpen={unitModal} toggle={() => setUnitModal(false)} size="lg" centered>
                <ModalHeader toggle={() => setUnitModal(false)}>Choisir unité</ModalHeader>
                <ModalBody>

                    {/* SEARCH */}
                    <div
                        className="pos-search-bar mb-3"
                        onClick={() => setKeypadField("unitSearch")}
                    >
                        <Input
                            readOnly
                            value={form.unitSearch || ""}
                            placeholder="Rechercher unité..."
                            className="pos-input"
                        />
                    </div>

                    <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                        {unites
                            .filter(u =>
                                !form.unitSearch ||
                                u.libelle.toLowerCase().includes(form.unitSearch.toLowerCase()) ||
                                u.code.toLowerCase().includes(form.unitSearch.toLowerCase())
                            )
                            .map(u => (
                                <Button
                                    key={u.code}
                                    color={form.unite === u.code ? "primary" : "light"}
                                    className="w-100 text-start mb-2 py-3 fw-bold"
                                    onClick={() => {
                                        setField("unite", u.code);
                                        setUnitModal(false);
                                    }}
                                >
                                    {u.libelle} ({u.code})
                                </Button>
                            ))}
                    </div>

                </ModalBody>
            </Modal>
        </>
    );
};

export default POSProductFormModal;
